import i18next from "i18next";
import * as yup from "yup";

export function validation(rowData) {
  return yup.object().shape({
    title: yup
      .string()
      .required(i18next.t("validation.coupen.title"))
      .min(3, "Minimum 3 Character required")
      .trim(i18next.t("validation.common.noSpace")),
    description: yup
      .string()
      .required(i18next.t("validation.coupen.description"))
      .min(3, "Minimum 3 Character required")
      .trim(i18next.t("validation.common.noSpace")),
    minDiscount: yup
      .string()
      .required(i18next.t("validation.coupen.minDiscount"))
      .trim(i18next.t("validation.common.noSpace")),
    maxDiscount: yup
      .string()
      .required(i18next.t("validation.coupen.maxDiscount"))
      .trim(i18next.t("validation.common.noSpace")),
    subscriptionId: yup
      .string()
      .required(i18next.t("validation.coupen.subscription")),
    startDate: yup.string().required(i18next.t("validation.coupen.startDate")),
    endDate: yup.string().required(i18next.t("validation.coupen.endDate")),
    limit:
      Object?.keys(rowData)?.length !== 0
        ? null
        : yup
          .number()
          .required(i18next.t("validation.coupen.limit"))
          .min(1, "Limit must be greater than 1")
  });
}
